export const contactFormItems = [
  { title: "Entity Name", name: "entity_name", disable: false },
  { title: "Type", name: "type", disabled: false },
  { title: "Phone Number", name: "phone_number", disabled: false },
  { title: "Email", name: "email", disable: false },
  { title: "Street", name: "street", disabled: false },
  { title: "City", name: "city", disabled: false },
  { title: "State", name: "state", disabled: false },
  { title: "Zip", name: "zip", disabled: false },
]